export const environment = {
    // DEV
   //  production: false,
   //  apiBaseUrl: 'http://localhost:5050',

    // DEMO
     production: true,
     apiBaseUrl: 'https://api-crm.safemgr.com',
       sentryEnvironment: 'production',
  sentryRelease: 'crm@prod'

    // PRODUCTION
    // production: true,
    // apiBaseUrl: 'https://api.safemgr.com'
  };
  